import { create } from 'zustand'

/**
 * Phase 1 RBAC §1.2 / §1.3: global "access denied" UI state.
 *
 * Set by the axios response interceptor whenever the backend returns 403.
 * Read by `<AccessDeniedOverlay />` mounted at the application root, which
 * renders a modal so direct URL navigation to a restricted page surfaces
 * a clear message instead of an opaque error.
 */
interface AccessDeniedState {
  shown: boolean
  message: string | null
  show: (message?: string) => void
  dismiss: () => void
}

const DEFAULT_MESSAGE =
  'You do not have permission to view this resource. Contact your organization owner or admin if you believe this is a mistake.'

export const useAccessDenied = create<AccessDeniedState>((set) => ({
  shown: false,
  message: null,
  show: (message) => set({ shown: true, message: message ?? DEFAULT_MESSAGE }),
  dismiss: () => set({ shown: false, message: null }),
}))
